provinceWaterUse ={
    "北京": 198.70024009727393,
    "天津": 100.41143108489716,
    "河北": 120.41869526890204,
    "石家庄市": 143.16477817238854,
    "晋州市": 191.34905993641323,
    "新乐市": 130.79982324348208,
    "唐山市": 145.93103651872164,
    "滦州市": 77.94671082342316,
    "遵化市": 89.52249041433711,
    "迁安市": 87.94520547945206,
    "秦皇岛市": 143.29746340955256,
    "邯郸市": 104.37431305793099,
    "武安市": 128.5287902945509,
    "邢台市": 58.36686826620497,
    "南宫市": 129.3252156265855,
    "沙河市": 111.28371698912584,
    "保定市": 114.66261969657349,
    "涿州市": 125.952444352397,
    "安国市": 195.48342267222552,
    "高碑店市": 79.82177560790633,
    "白沟新城": 136.68850506253725,
    "张家口市": 88.32302045638026,
    "承德市": 133.47754552079084,
    "平泉市": 104.1714853484925,
    "沧州市": 155.29914024627135,
    "泊头市": 197.12272789066688,
    "任丘市": 68.58311183806993,
    "黄骅市": 91.14336091143362,
    "河间市": 92.62363462003259,
    "廊坊市": 158.96265074347266,
    "霸州市": 88.00752807602123,
    "三河市": 108.95921902062668,
    "衡水市": 82.95442448294803,
    "深州市": 81.19292237442923,
    "辛集市": 150.90535432968773,
    "定州市": 117.37168027970094,
    "山西": 139.27869130833474,
    "太原市": 178.54798266855354,
    "古交市": 129.04613833095218,
    "大同市": 153.16678577271125,
    "阳泉市": 79.53740317890566,
    "长治市": 201.1074329768931,
    "潞城市": 97.23720259552992,
    "晋城市": 121.45216526734423,
    "高平市": 99.84825493171472,
    "朔州市": 101.28088593009859,
    "晋中市": 136.51118185978135,
    "介休市": 107.02062497304027,
    "运城市": 120.70282250527384,
    "永济市": 123.5784440423882,
    "河津市": 64.63013698630138,
    "忻州市": 74.96950950066284,
    "原平市": 69.49839480527027,
    "临汾市": 86.66115443920535,
    "侯马市": 140.11349803692974,
    "霍州市": 100.95552736531812,
    "吕梁市": 106.00456621004565,
    "孝义市": 102.76375871184811,
    "汾阳市": 74.4515440750871,
    "内蒙古": 97.84380256922843,
    "呼和浩特市": 71.88602721150826,
    "包头市": 79.59383795119093,
    "乌海市": 150.18445607951188,
    "赤峰市": 105.21783479753755,
    "通辽市": 148.18969546614895,
    "霍林郭勒市": 157.46419063837124,
    "鄂尔多斯市": 79.87211852832843,
    "呼伦贝尔市": 170.59679881338707,
    "满洲里市": 112.3522281454062,
    "牙克石": 124.56592598904962,
    "扎兰屯市": 70.76087184543412,
    "额尔古纳市": 80.29792649150386,
    "根河市": 73.03730174486577,
    "巴彦淖尔市": 88.97187408918681,
    "乌兰察布市": 119.85568822796864,
    "丰镇市": 90.62091536901906,
    "乌兰浩特市": 132.07732414235,
    "阿尔山市": 48.046999970915856,
    "二连浩特": 65.2688720489653,
    "锡林浩特市": 125.22307402287295,
    "辽宁": 151.86185530622498,
    "沈阳市": 245.20814587567293,
    "新民市": 131.0948905109489,
    "大连市": 150.1471731355342,
    "瓦房店市": 76.1635520818176,
    "庄河市": 58.35916120535327,
    "鞍山市": 113.90457238059977,
    "海城市": 184.75318494612338,
    "抚顺市": 114.84392544352121,
    "本溪市": 120.14830207530336,
    "丹东市": 116.21588926274264,
    "东港市": 146.8546674026126,
    "凤城市": 86.15848326947273,
    "锦州市": 111.85094080891189,
    "凌海市": 68.49315068493152,
    "北镇市": 127.30296178376241,
    "营口市": 129.56007266656846,
    "盖州市": 84.01204626619051,
    "大石桥市": 77.3585103263374,
    "阜新市": 71.59817351598173,
    "辽阳市": 144.93100454229065,
    "灯塔市": 142.20255925002192,
    "盘锦市": 118.17918668527435,
    "铁岭市": 150.99289511347374,
    "调兵山市": 207.81436368236527,
    "开原市": 69.28746288869213,
    "朝阳市": 96.9728463224804,
    "北票市": 84.35851272015655,
    "凌源市": 90.41095890410959,
    "葫芦岛市": 103.28767123287672,
    "兴城市": 129.9847792998478,
    "吉林": 117.54292303264326,
    "长春市": 135.53215995177246,
    "榆树市": 70.55761421187145,
    "德惠市": 77.25564996242991,
    "吉林市": 117.10119310649578,
    "蛟河市": 51.42022562449637,
    "桦甸市": 65.87959625090123,
    "舒兰市": 44.96944151738673,
    "磐石市": 132.19178082191783,
    "四平市": 79.73986729975839,
    "双辽市": 192.5636007827789,
    "辽源市": 103.74949744498113,
    "通化市": 86.89698982351534,
    "集安市": 89.04995658260823,
    "白山市": 76.17497918716415,
    "临江市": 69.42943981101364,
    "松原市": 146.13557528367335,
    "扶余市": 117.45846691926553,
    "白城市": 109.03482995549025,
    "洮南市": 132.39130434782612,
    "大安市": 73.34807625366014,
    "延吉市": 145.16379842413647,
    "图们市": 88.5949119373777,
    "敦化市": 87.34356715082262,
    "珲春市": 183.30200700860146,
    "龙井市": 195.0451763334305,
    "和龙市": 77.3972602739726,
    "公主岭市": 99.4189372271564,
    "梅河口市": 90.58908350651004,
    "长白山保护开发区管理委员会": 287.432114776688,
    "黑龙江": 125.4629347437633,
    "哈尔滨市": 149.4846947404025,
    "尚志市": 181.19665782112887,
    "五常市": 109.94274429469371,
    "齐齐哈尔市": 126.9750319300794,
    "讷河市": 80.46016757547545,
    "鸡西市": 95.36354056902002,
    "虎林市": 107.86938424559827,
    "密山市": 130.76804679082653,
    "鹤岗市": 90.20455565233456,
    "双鸭山市": 109.54638521912932,
    "大庆市": 130.02940038460758,
    "伊春市": 87.02627631340357,
    "铁力市": 199.94589409999753,
    "佳木斯市": 114.71730625604336,
    "同江市": 70.15863763167756,
    "富锦市": 75.90388502133393,
    "抚远市": 101.10893672537507,
    "七台河市": 95.4419596725047,
    "牡丹江市": 130.8300717547293,
    "海林市": 96.02878096028782,
    "宁安市": 119.6981906087466,
    "穆棱市": 107.63358778625954,
    "绥芬河市": 116.98630136986301,
    "东宁市": 92.7558009505172,
    "黑河市": 100.21140446508981,
    "北安市": 109.12107547009272,
    "五大连池市": 123.38864393658913,
    "绥化市": 155.8178329185112,
    "安达市": 63.08066971080671,
    "肇东市": 73.68721461187215,
    "海伦市": 66.7845043452644,
    "上海": 203.29691073503778,
    "江苏": 214.01350224025072,
    "南京市": 279.53001108897024,
    "无锡市": 233.5679946145395,
    "江阴市": 179.55340675082817,
    "宜兴市": 191.3621333791386,
    "徐州市": 167.35304548422485,
    "新沂市": 158.61571737563085,
    "邳州市": 131.67060774081324,
    "常州市": 223.42455804404608,
    "溧阳市": 251.23243339096507,
    "苏州市": 285.0829682602068,
    "常熟市": 277.13913602912334,
    "张家港市": 205.3367579908676,
    "昆山市": 319.9910649814806,
    "太仓市": 154.7703180212014,
    "南通市": 199.67004584652602,
    "海安市": 165.54264148194687,
    "启东市": 124.54250758130293,
    "如皋市": 179.0346871745574,
    "海门市": 182.01064839137155,
    "连云港市": 173.93705094100392,
    "淮安市": 142.38635344941665,
    "盐城市": 141.3243199400921,
    "东台市": 115.2186588921283,
    "扬州市": 198.39400019322326,
    "仪征市": 159.2192878779072,
    "高邮市": 113.04125174642226,
    "镇江市": 208.00703047309227,
    "丹阳市": 111.86863750507497,
    "扬中市": 188.3541995771737,
    "句容市": 208.4901399969893,
    "泰州市": 158.99415019225648,
    "兴化市": 131.26861226920786,
    "靖江市": 155.4703196347032,
    "泰兴市": 129.7777649197417,
    "宿迁市": 135.00308422853553,
    "浙江": 204.36106693789472,
    "杭州市": 231.0840068508945,
    "建德市": 224.10808369712475,
    "宁波市": 235.01297152583734,
    "余姚市": 161.74482006543073,
    "慈溪市": 124.67897468220367,
    "温州市": 165.93011937245257,
    "瑞安市": 165.6829027957571,
    "乐清市": 141.34516602575763,
    "嘉兴市": 201.64039806809782,
    "海宁市": 265.53476662687484,
    "平湖市": 119.92239402669173,
    "桐乡市": 159.4567290656735,
    "湖州市": 193.50589862149428,
    "绍兴市": 220.8915430022514,
    "诸暨市": 222.85751799078423,
    "嵊州市": 160.72312214971078,
    "金华市": 224.8057000246384,
    "兰溪市": 157.66257796878264,
    "义乌市": 152.3162165213426,
    "东阳市": 188.20494995793288,
    "永康市": 213.0351888383165,
    "衢州市": 244.51689958562315,
    "江山市": 143.8565112372228,
    "舟山市": 136.00207582115726,
    "台州市": 248.95962907040726,
    "玉环市": 147.76424251698188,
    "温岭市": 172.9281646474197,
    "临海市": 174.32896534190556,
    "丽水市": 197.99970540580347,
    "龙泉市": 184.07571390366385,
    "安徽": 190.67859443290104,
    "合肥市": 249.18478790428753,
    "巢湖市": 104.83250834580406,
    "芜湖市": 182.02285452459503,
    "蚌埠市": 233.64979910291152,
    "淮南市": 132.4390218356467,
    "马鞍山市": 198.93760524279799,
    "淮北市": 113.31926952711206,
    "铜陵市": 218.21331784251055,
    "安庆市": 182.04015227930887,
    "潜山市": 191.16578138104558,
    "桐城市": 170.24491490244915,
    "黄山市": 171.80655116642637,
    "滁州市": 165.8435614279392,
    "天长市": 204.879224231095,
    "明光市": 145.3910737958462,
    "阜阳市": 157.876938977181,
    "界首市": 131.03037522334722,
    "宿州市": 112.88750834560511,
    "六安市": 182.79405013106086,
    "亳州市": 181.19497091386754,
    "池州市": 169.8789784343029,
    "宣城市": 216.07752170584683,
    "宁国市": 102.78500441272398,
    "福建": 210.1043695171416,
    "福州市": 250.37754338477143,
    "福清市": 204.19878765794797,
    "厦门市": 194.93090407514478,
    "莆田市": 145.279843444227,
    "三明市": 296.86385424475793,
    "永安市": 245.82310555071666,
    "泉州市": 214.38760178338916,
    "石狮市": 260.73675375576556,
    "晋江市": 232.683426343646,
    "南安市": 98.36650297234426,
    "漳州市": 244.23351915943047,
    "龙海市": 118.00551941159576,
    "南平市": 199.57376910441505,
    "邵武市": 159.65374146624424,
    "武夷山市": 195.27574703669532,
    "建瓯市": 117.33343711083438,
    "龙岩市": 191.83487175175514,
    "漳平市": 117.03058619118752,
    "宁德市": 179.03191135950595,
    "福安市": 246.1320316510883,
    "福鼎市": 272.13835305811824,
    "江西": 174.6132133746005,
    "南昌市": 237.21526418786695,
    "景德镇市": 253.709516465572,
    "乐平市": 149.33704490513512,
    "萍乡市": 163.18534629690527,
    "九江市": 173.18956859857977,
    "瑞昌市": 117.0958904109589,
    "共青城市": 97.5388738395689,
    "庐山市": 130.83948015454865,
    "新余市": 205.49356562386208,
    "鹰潭市": 150.2341370967,
    "贵溪市": 221.72666454284803,
    "赣州市": 151.93678384339145,
    "瑞金市": 112.44292237442923,
    "吉安市": 144.45068134860446,
    "井冈山市": 78.67579908675799,
    "宜春市": 138.5027226474221,
    "丰城市": 130.4666579388977,
    "樟树市": 119.55403473621415,
    "高安市": 106.70621052959048,
    "抚州市": 122.89286951240109,
    "上饶市": 176.05824016585817,
    "德兴市": 101.96611192875201,
    "山东": 126.55959507913563,
    "济南市": 142.52879171877277,
    "青岛市": 152.46813138073747,
    "胶州市": 135.25890112513804,
    "平度市": 117.12796055519527,
    "莱西市": 127.87808970474069,
    "淄博市": 125.71687695858274,
    "枣庄市": 130.75909051287724,
    "滕州市": 158.26671222727074,
    "东营市": 176.7767734686121,
    "烟台市": 104.10225761960527,
    "龙口市": 73.09144761199556,
    "莱阳市": 62.054558743781385,
    "莱州市": 87.03898840885142,
    "蓬莱市": 133.0090329883818,
    "招远市": 98.60470718927132,
    "栖霞市": 113.45401174168299,
    "海阳市": 105.16194813222108,
    "潍坊市": 120.23932355696057,
    "青州市": 109.92681553762432,
    "诸城市": 133.76082395785377,
    "寿光市": 87.5435156084322,
    "安丘市": 116.4419897532793,
    "高密市": 123.81661901790785,
    "昌邑市": 208.36054364277538,
    "济宁市": 116.91373527792395,
    "曲阜市": 100.16643195493535,
    "邹城市": 116.50247741183328,
    "泰安市": 137.90816870570342,
    "新泰市": 106.72590398617795,
    "肥城市": 117.45436709525977,
    "威海市": 137.80920927009,
    "荣成市": 80.27624100515432,
    "乳山市": 118.85192433137638,
    "日照市": 139.11111111111114,
    "莱芜市": 84.70319634703196,
    "临沂市": 112.79763674685861,
    "德州市": 87.62413743677948,
    "乐陵市": 161.4344633125013,
    "禹城市": 98.981277150907,
    "聊城市": 112.64799063691258,
    "临清市": 87.69948630136986,
    "滨州市": 160.67215270361206,
    "邹平市": 109.50626991681496,
    "菏泽市": 126.6218121678989,
    "河南": 134.78581431421762,
    "郑州市": 140.38327462866866,
    "巩义市": 112.95187816461905,
    "荥阳市": 164.74946829190205,
    "新密市": 98.85210254292518,
    "新郑市": 154.32667750174136,
    "登封市": 79.09187529522909,
    "开封市": 139.93957703927492,
    "洛阳市": 123.01089464614306,
    "偃师市": 112.96101159114858,
    "平顶山市": 145.53888526491266,
    "舞钢市": 120.59360730593609,
    "汝州市": 137.8108104924675,
    "安阳市": 198.99062725306416,
    "林州市": 136.54009191914685,
    "鹤壁市": 115.17209623575457,
    "新乡市": 184.29963833382206,
    "卫辉市": 177.41631134899754,
    "辉县市": 167.85470774189548,
    "焦作市": 128.26880434298326,
    "沁阳市": 75.03269773525159,
    "孟州市": 96.92168691192174,
    "濮阳市": 166.6944331293566,
    "许昌市": 163.64146030200428,
    "禹州市": 108.91264821207929,
    "长葛市": 106.35038732548473,
    "漯河市": 120.21644330395398,
    "三门峡市": 104.36684834535492,
    "义马市": 105.82429055015977,
    "灵宝市": 122.99904531426921,
    "南阳市": 109.27298589855438,
    "邓州市": 88.60682341109604,
    "商丘市": 103.49034382577794,
    "永城市": 115.84589555639842,
    "信阳市": 129.89961676860946,
    "周口市": 185.5006457971649,
    "项城市": 96.2231712051467,
    "驻马店市": 171.7289957330173,
    "济源市": 135.95632917911215,
    "湖北": 202.19327055141596,
    "武汉市": 260.0193989315665,
    "黄石市": 175.57696259679764,
    "大冶市": 116.56682308077187,
    "十堰市": 254.41864805345077,
    "丹江口市": 125.97840066962007,
    "宜昌市": 198.1616506018248,
    "宜都市": 102.29377730006634,
    "当阳市": 130.04663363450888,
    "枝江市": 130.41393833923578,
    "襄阳市": 117.31615553840257,
    "老河口市": 140.61400184092264,
    "枣阳市": 152.38659680410194,
    "宜城市": 112.5997290380852,
    "鄂州市": 206.08615129163076,
    "荆门市": 139.4154899710309,
    "钟祥市": 178.4921507849215,
    "孝感市": 174.85476836795723,
    "应城市": 158.3818966169681,
    "安陆市": 157.11978900341788,
    "汉川市": 141.92873860922666,
    "荆州市": 182.3323927676277,
    "石首市": 131.17756421521926,
    "洪湖市": 203.47657654059668,
    "松滋市": 153.40802793772218,
    "黄冈市": 190.5649671719219,
    "麻城市": 90.90311332503113,
    "武穴市": 194.96002618168217,
    "咸宁市": 168.48219178082195,
    "赤壁市": 168.65753424657535,
    "随州市": 158.1852375282374,
    "广水市": 159.62648108179536,
    "恩施市": 215.08512720156554,
    "利川市": 151.07632093933466,
    "仙桃市": 178.99340436326736,
    "潜江市": 138.58353533645266,
    "天门市": 103.27906380484944,
    "湖南": 211.92256554971163,
    "长沙市": 347.2914995176229,
    "宁乡市": 137.79712768602155,
    "浏阳市": 166.99583405750155,
    "株洲市": 286.7152049327429,
    "醴陵市": 152.91213504912136,
    "湘潭市": 251.26426079344566,
    "湘乡市": 128.24249489944623,
    "韶山市": 150.82912761355445,
    "衡阳市": 128.6369867777114,
    "耒阳市": 156.69228483361783,
    "常宁市": 135.7142857142857,
    "邵阳市": 163.79647749510764,
    "武冈市": 119.55168119551682,
    "岳阳市": 145.9888451754594,
    "汨罗市": 155.94777620413458,
    "临湘市": 131.37899543378998,
    "常德市": 127.45724926455141,
    "津市市": 133.97008922960916,
    "张家界市": 185.18991420875668,
    "益阳市": 162.73693297954728,
    "沅江市": 150.35616438356163,
    "郴州市": 172.85821028286784,
    "资兴市": 115.64510803475794,
    "永州市": 219.42233067004537,
    "怀化市": 188.24578142084115,
    "洪江市": 122.72244847587314,
    "娄底市": 194.43949096214638,
    "冷水江市": 130.04246434264917,
    "涟源市": 115.6967105837187,
    "吉首市": 220.04783648619264,
    "广东": 254.37052665694716,
    "广州市": 299.6021271814221,
    "韶关市": 303.1811215886825,
    "乐昌市": 130.90593607305937,
    "南雄市": 147.65450381888738,
    "深圳市": 229.5695662643761,
    "珠海市": 305.56923874487865,
    "汕头市": 188.9039473470734,
    "佛山市": 306.7995604028957,
    "江门市": 269.2975597138907,
    "台山市": 393.7084367625878,
    "开平市": 152.85952937807264,
    "鹤山市": 220.48255597400987,
    "恩平市": 242.39269406392694,
    "湛江市": 216.50164031319684,
    "廉江市": 135.34246575342465,
    "雷州市": 121.5875250419622,
    "吴川市": 105.52632949632793,
    "茂名市": 213.65284443663435,
    "高州市": 118.11497225689068,
    "化州市": 128.67031963470322,
    "信宜市": 109.40820109408202,
    "肇庆市": 287.12268670768805,
    "四会市": 250.39435450394353,
    "惠州市": 249.96711378398945,
    "梅州市": 226.20625264417112,
    "兴宁市": 202.00425797294676,
    "汕尾市": 184.0412145960447,
    "陆丰市": 215.00326157860405,
    "河源市": 261.34243188783717,
    "阳江市": 250.5861977803795,
    "阳春市": 146.32627646326276,
    "清远市": 275.52004058853373,
    "英德市": 234.30105404445143,
    "连州市": 149.7716894977169,
    "东莞市": 257.95106663661767,
    "潮州市": 205.60899116826445,
    "揭阳市": 176.22864182667067,
    "普宁市": 137.57017740848866,
    "云浮市": 193.1118023568822,
    "罗定市": 148.675799086758,
    "广西": 266.1428728832899,
    "南宁市": 317.4177154196012,
    "柳州市": 258.64152896900265,
    "桂林市": 322.62429860799534,
    "荔浦市": 229.69939117199388,
    "梧州市": 231.23402244197956,
    "岑溪市": 147.27215139757698,
    "北海市": 312.9997204361197,
    "防城港市": 282.4292973928414,
    "东兴市": 242.5872051970061,
    "钦州市": 365.55859969558594,
    "贵港市": 190.28735982741074,
    "桂平市": 204.960514147711,
    "玉林市": 139.21814746992843,
    "北流市": 155.1340592436483,
    "百色市": 287.57316888237375,
    "靖西市": 124.69904524699045,
    "贺州市": 224.34842996813637,
    "河池市": 232.99182686773338,
    "来宾市": 215.07634929232702,
    "合山市": 127.78934120722202,
    "崇左市": 249.97837058399423,
    "凭祥市": 222.4264641397576,
    "海南": 197.60561953198047,
    "海口市": 181.42162802950475,
    "三亚市": 250.52717631462656,
    "三沙市": 119.86301369863014,
    "儋州市": 193.42720827367114,
    "五指山市": 196.67318982387476,
    "琼海市": 186.5643317464944,
    "文昌市": 184.8291383069337,
    "万宁市": 197.79299847792998,
    "东方市": 274.9395648670427,
    "重庆": 165.5316595000688,
    "重庆市": 165.5316595000688,
    "四川": 181.3622894931356,
    "成都市": 236.08203085566416,
    "都江堰市": 242.82364556337163,
    "彭州市": 118.81508550102777,
    "邛崃市": 134.17325662299965,
    "崇州市": 193.23395255955847,
    "简阳市": 109.90157168999976,
    "自贡市": 125.11646328290746,
    "攀枝花市": 216.78201662618508,
    "泸州市": 126.50478602464618,
    "德阳市": 137.80154935351558,
    "广汉市": 168.5949119373777,
    "什邡市": 210.43930089749645,
    "绵竹市": 160.53576864535768,
    "绵阳市": 169.3552660005533,
    "江油市": 168.88454011741683,
    "广元市": 196.03588067589175,
    "遂宁市": 168.2898806893504,
    "内江市": 136.48258109682953,
    "隆昌市": 129.70870284856798,
    "乐山市": 137.86368430979442,
    "峨眉山市": 252.22339304531084,
    "南充市": 153.6478944698123,
    "阆中市": 159.68688845401175,
    "眉山市": 172.29832572298326,
    "宜宾市": 120.29976484972181,
    "广安市": 142.73935428709507,
    "华蓥市": 138.40584853431756,
    "达州市": 148.05572595093656,
    "万源市": 94.53881278538813,
    "雅安市": 173.9026097390261,
    "巴中市": 129.97769990442814,
    "资阳市": 147.56585879873552,
    "马尔康市": 298.1885694214461,
    "康定市": 210.19406392694063,
    "西昌市": 203.60292737849505,
    "贵州": 185.86014898536578,
    "贵阳市": 247.80070756114148,
    "清镇市": 158.0185415801854,
    "六盘水市": 159.60270189611904,
    "盘州市": 104.51650664028206,
    "遵义市": 143.0074596500746,
    "赤水市": 102.989701029897,
    "仁怀市": 99.54829093011261,
    "安顺市": 166.2817153067302,
    "毕节市": 101.29246239513336,
    "铜仁市": 191.10546378653115,
    "兴义市": 154.29708904109592,
    "兴仁市": 135.07141663882393,
    "凯里市": 161.6417484711661,
    "都匀市": 178.21079659596356,
    "福泉市": 173.26577844498652,
    "云南": 138.96249188112049,
    "昆明市": 121.7183290909778,
    "安宁市": 137.05869046122913,
    "曲靖市": 139.68006606940878,
    "宣威市": 100.21529140549087,
    "玉溪市": 127.40333901874756,
    "保山市": 91.84875611622769,
    "腾冲市": 145.01735159817352,
    "昭通市": 165.4116014289753,
    "丽江市": 283.90827055699083,
    "普洱市": 170.74595857949748,
    "临沧市": 117.12232433578019,
    "楚雄市": 198.67167448591883,
    "个旧市": 128.32465753424654,
    "开远市": 148.40759481404055,
    "蒙自市": 170.45139203448255,
    "弥勒市": 121.43172779496243,
    "文山市": 172.37715648230397,
    "景洪市": 134.11716262619578,
    "大理市": 237.00507858044284,
    "瑞丽市": 53.08219178082191,
    "芒市": 163.20939334637964,
    "泸水市": 346.94358521137127,
    "香格里拉市": 136.1123249672259,
    "西藏": 162.9717596362405,
    "拉萨市": 201.64642331516552,
    "日喀则市": 150.16875124081793,
    "昌都市": 100.0,
    "林芝市": 115.56662515566624,
    "山南市": 231.84059775840598,
    "那曲市": 84.68244084682442,
    "陕西": 163.39341378389483,
    "西安市": 191.0220999415542,
    "铜川市": 73.4931506849315,
    "宝鸡市": 160.58976077029976,
    "咸阳市": 180.28484922771733,
    "彬州市": 75.79908675799086,
    "兴平市": 105.33013698630138,
    "渭南市": 170.93961866512913,
    "韩城市": 104.40835266821345,
    "华阴市": 83.02200083022001,
    "延安市": 94.18739726027395,
    "汉中市": 172.9407388532047,
    "榆林市": 95.77878672242684,
    "神木市": 111.67595698980551,
    "安康市": 117.76056497572371,
    "商洛市": 109.61583548246642,
    "杨凌区": 131.65394869908982,
    "甘肃": 137.17383865682214,
    "兰州市": 183.52500404200893,
    "嘉峪关市": 74.93469807462738,
    "金昌市": 260.4049682495308,
    "白银市": 111.71881581829517,
    "天水市": 90.4364003530001,
    "武威市": 137.1463679834436,
    "张掖市": 190.29895752563112,
    "平凉市": 64.48767123287672,
    "华亭市": 80.9464508094645,
    "酒泉市": 102.96821255936602,
    "玉门市": 68.15644438143508,
    "敦煌市": 117.41682974559689,
    "庆阳市": 80.14720915968104,
    "定西市": 54.648153445947294,
    "陇南市": 77.282057726949,
    "临夏市": 137.85570181793864,
    "合作市": 113.2420091324201,
    "青海": 178.51287791704524,
    "西宁市": 180.66240903015003,
    "海东市": 96.78344690224775,
    "玉树市": 205.3477344573235,
    "格尔木市": 261.90547248833576,
    "德令哈市": 229.5604111577231,
    "宁夏": 147.27699795178233,
    "银川市": 156.808141492089,
    "灵武市": 164.59951651893633,
    "宁东能源化工基地": 58.20053203391096,
    "石嘴山市": 144.51234998537228,
    "吴忠市": 150.20179080296825,
    "青铜峡市": 178.15960947076405,
    "固原市": 109.58904109589041,
    "中卫市": 119.86301369863011,
    "新疆": 191.4136463404834,
    "乌鲁木齐市": 187.79369663131428,
    "克拉玛依市": 234.99220464693863,
    "吐鲁番市": 124.68296093824493,
    "哈密市": 246.97693097139793,
    "昌吉市": 145.43195943054297,
    "阜康市": 175.70844985115787,
    "博乐市": 80.42784762619627,
    "阿拉山口市": 299.99999999999994,
    "库尔勒市": 187.06758369806172,
    "阿克苏市": 165.78320428826683,
    "阿图什市": 262.4258646932241,
    "喀什市": 265.25529265255295,
    "和田市": 255.40903853539882,
    "伊宁市": 187.10903476126376,
    "奎屯市": 202.70805289413255,
    "霍尔果斯市": 244.61839530332682,
    "塔城市": 253.99911621741052,
    "乌苏市": 112.64114174356622,
    "阿勒泰市": 136.33912199331246,
    "石河子市": 98.26397608612884,
    "阿拉尔市": 231.41941125036433,
    "图木舒克市": 222.06200432588318,
    "五家渠市": 207.10410958904112,
    "北屯市": 451.18380699243505,
    "铁门关市": 155.13424657534247,
    "双河市": 157.07762557077626,
    "昆玉市": 388.5148208343008
    }